module.exports = __webpack_public_path__ + "portal/assets/img/logo.c43891ac.svg";